import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
//import _ from 'lodash';
//import $ from 'jquery';
//import Swal from 'sweetalert2';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';

import { LOADING_MESSAGE } from './AI.constants';

export default {
  name: 'AI',

  components: {
    WayFindBar,
    Footer,
    Aside,
    Spinner,
    Player,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,

      txtSearch: '',

      isGetSearch: false,

      isShowPlayer: false,
    };
  },

  computed: {
    ...mapState('AI', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    ...mapGetters('AI', {
      mg_res_search: 'res_search',
      mg_selectedVideo: 'selectedVideo',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    c_isSearchDisabled() {
      return '' === this.txtSearch;
    },
  },

  methods: {
    ...mapMutations('AI', {
      mm_SET_SELECTED_BULLET_ID: 'SET_SELECTED_BULLET_ID',
    }),

    ...mapActions('AI', {
      ma_makeAiSearch: 'makeAiSearch',
    }),

    gotoLogin() {
      this.$router.push(`/login?login_redirect_uri=${encodeURIComponent(this.$route.fullPath)}`);
    },

    async search() {
      await this.ma_makeAiSearch({
        search: this.txtSearch,
      });
      this.isGetSearch = true;
      await this.$nextTick();
      window.scrollTo(0, 0);
    },

    async searchFollowup(followup) {
      this.txtSearch = followup;
      await this.search();
    },

    openPlayer() {
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    selectBulletAndOpenPlayer(bulletId) {
      this.mm_SET_SELECTED_BULLET_ID(bulletId);
      this.openPlayer();
    },
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
